import styled from "styled-components";
import { setFontVariant } from "@similarweb/styles";

export const StyledEnrichmentErrorContainer = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    ${setFontVariant("h2")}
`;
